import { EasmFindingDetailsWebComponent } from './component/EasmFindingDetailsWebComponent';
import { WEB_COMPONENT_EASM_FINDING_DETAILS } from '../../webcomponents.constants';

export { EasmFindingDetailsWebComponent };

window.customElements.define(WEB_COMPONENT_EASM_FINDING_DETAILS, EasmFindingDetailsWebComponent);
